// firebase-config.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAMmgPOCaHBL7tJ1MQpelvIa3Qlp5pOYLg",
  authDomain: "freetogodashboard-bf4ab.firebaseapp.com",
  projectId: "freetogodashboard-bf4ab",
  storageBucket: "freetogodashboard-bf4ab.appspot.com",
  messagingSenderId: "496720129280",
  appId: "1:496720129280:web:8169f26bffabc6e45197e5",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage };
